import { Skeleton } from 'antd';
import { useRequest, useLocation, useParams } from 'umi';
// import MarkDown from 'react-markdown';
// import rehypeHighlight from 'rehype-highlight'; // for code highlight
// import remarkGfm from 'remark-gfm'; // for Strikethrough
// import rehypeRaw from 'rehype-raw'; // for html
import parse, { domToReact } from 'html-react-parser';
import { getArticleDetail } from './services';

import styles from './index.less';

const GrowDetail = () => {
  const location: any = useLocation();
  const params: { id: string } = useParams();
  const { id } = params;
  const { country } = location.query;
  const { loading, data = {} } = useRequest(getArticleDetail, {
    defaultParams: [{ id, country }],
  });

  // const linkConverter = (str: string) => {
  //   let result = '';
  //   const reg = /(?<!!)\[(.*?)\]\((.*?)\)/gi;
  //   if (str) {
  //     result = str.replace(reg, ($0, $1, $2) => {
  //       const url = new URL($2);
  //       url.searchParams.set('igniteOpenInBrowser', 'true'); // 此标识用于在app webview中的链接使用外部浏览器打开
  //       return `[${$1}](${url})`;
  //     });
  //   }
  //   return result;
  // };

  // const finalContent = linkConverter(data?.content);

  if (loading) {
    return (
      <div className={styles.skeletonWrap}>
        <Skeleton.Input active className={styles.skeletonTitle} />
        <Skeleton active className={styles.skeletonContent} />
      </div>
    );
  }

  return (
    <div>
      <div className={styles.coverContainer}>
        <img src={data.cover_url} className={styles.coverImg} />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.articleTitle}>{data.title}</div>
        <div className={styles.tagsContainer}>
          {data?.tags?.map((item: string) => (
            <Tag title={item} key={item} />
          ))}
        </div>
        <div className={styles.mainContainer}>
          <div
            className="ck-content"
            // dangerouslySetInnerHTML={{
            //   __html: data?.content,
            // }}
          >
            {parse(data?.content ?? '', {
              replace: (domNode: any) => {
                const { attribs, children } = domNode;
                if (!attribs) {
                  return;
                }

                if (attribs.class === 'table') {
                  return (
                    <div className="table-warp">{domToReact([domNode])}</div>
                  );
                }
              },
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const Tag = ({ title }: { title: string }) => {
  return <div className={styles.tag}>{title}</div>;
};

export default GrowDetail;
